/**
 * Created by sswaminathan on 7/13/22
 * File: UsageAlertModel
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Button, ModalBody, Modal, Body, Bold, ModalFooter, ModalHeader, Banner } from '@panwds/react-ui'
import { useCallback, useEffect, useState } from 'react'
/**
 *   TODO: Brief what is this component/class do
 */
import {
  CONTINUE_BUTTON_TEXT
} from '../constants/SubscriptionConstant'


const UsageAlertModel = (props) => {
  const { closeModal,
    isOpen,
    title,
    continueModal,
    values,
    content,
    showBanner,
    showClose } = props
  const [open, setOpen] = useState(isOpen)

  const getTitle = useCallback(() => {
    return <Body size="md" appearance="secondary">
      <Bold>
        {title}
      </Bold>
    </Body>
  }, [title])

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])
  const continueSubmission = useCallback(() => {
    continueModal(values)
    setOpen(false)
    //closeModal()
  }, [continueModal, values])
  return (
    <Modal style={{ top: '12%', height: '200px', width: '600px ' }}
      onClose={closeModal}
      isOpen={open}
      confirmClose={false}
    >
      <div className='tw-flex tw-flex-col tw-h-full'>
        <ModalHeader title={getTitle()} />
        <ModalBody addClassName='tw-text-center' >
          <Body size="md" appearance="secondary">
            {showBanner && <Banner appearance="warning" showIcon>
              {content}
            </Banner>}
            {!showBanner && content}
          </Body>
        </ModalBody>
        <ModalFooter>
          {showClose && <Button onClick={closeModal}>
            Close
          </Button>
          }
          <Button onClick={continueSubmission} appearance="secondary-destructive">
            {CONTINUE_BUTTON_TEXT}
          </Button>
        </ModalFooter>
      </div>
    </Modal>)
}

export default UsageAlertModel
